import React, { Component } from 'react';
import BasicMap from './map/BasicMap';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import ErasableTrack from './map/ErasableTrack';
import GeojsonLine from './map/GeojsonLine';
import WindDirectionArrow from '../../../track/wind-direction-arrow.svg';

export default class Map extends Component {

  static propTypes = {
    target: PropTypes.object,
    windDirection: PropTypes.number,
    showGeojsonLine: PropTypes.bool,
    geojsonPoints: PropTypes.array,
  }

  constructor(props) {
    super(props);
    this.uuid = uuidv4();
    this.state = {
      map: null,
      baseTrack: null,
      track2: null,
      geojsonLine: null,
    };
  }

  componentDidMount() {
    if (this.props.target.legs.isEmpty()) {
      // We can't draw anything if we don't have data
      return;
    }
    this.state.map = new BasicMap({
      bindTo: this.uuid,
      mapCenter: this.props.target.getMapCenter(),
      handleClickOnMap: this.props.handleClickOnMap,
      buoy_coordinate: this.props.target.buoy_coordinate,
    });
    // Base track (Full) is now managed in render to support Ghost layering
  }

  render() {

    if (this.state.map) {
      // 1. Clean up existing tracks
      if (this.state.baseTrack) {
        this.state.map.removeFeatures(this.state.baseTrack.getFeatures());
      }
      if (this.state.track2) {
        this.state.map.removeFeatures(this.state.track2.getFeatures());
      }
      if (this.state.geojsonLine) {
        this.state.map.removeFeatures(this.state.geojsonLine.getFeatures());
      }

      const fullGpses = this.props.target.gpses || [];
      const selectedGpses = this.props.selectedGpses || [];
      const isLegSelected = selectedGpses.length > 0 && selectedGpses.length < fullGpses.length;

      // 2. Draw Full Practice Track (always visible, so there's a track to
      //    reference when setting the buoy mark or drawing a GeoJSON line).
      //    Dim it to ghost gray when a Leg subset is highlighted on top.
      this.state.baseTrack = new ErasableTrack(
        this.uuid + '-ghost',
        fullGpses,
        isLegSelected ? 'rgba(128, 128, 128, 0.4)' : this.props.target.themeColor1,
      );
      this.state.map.addFeatures(this.state.baseTrack.getFeatures());

      // 3. Draw Selected Leg Track (Main), highlighted on top, if any
      if (isLegSelected) {
        this.state.track2 = new ErasableTrack(
          this.uuid + '-main',
          selectedGpses,
          this.props.target.themeColor1,
        );
        this.state.map.addFeatures(this.state.track2.getFeatures());
      } else {
        this.state.track2 = null;
      }

      // 4. by_geojson モード: クリックした2点分の点/線を描画
      if (this.props.showGeojsonLine && this.props.geojsonPoints && this.props.geojsonPoints.length > 0) {
        this.state.geojsonLine = new GeojsonLine(this.props.geojsonPoints);
        this.state.map.addFeatures(this.state.geojsonLine.getFeatures());
      } else {
        this.state.geojsonLine = null;
      }
    }

    return (
      <div id={this.uuid} className='ol-tracking-map'>
        <div className='wind-direction-icon'>
          <span className='top-label'>WIND</span>
          <span className='arrow-label'>
            <img className='arrow-img' src={WindDirectionArrow} style={{ transform: `rotateZ(${this.props.windDirection}deg)` }} />
          </span>
        </div>
      </div>
    );
  }
}
